export default __webpack_public_path__ + "1c55b07489f0d5c5535e2e8c58c6632d.png";